import React from "react";
// import ModalVideo from 'react-modal-video';
import "../../../node_modules/react-modal-video/scss/modal-video.scss";
// import { Link } from 'react-router-dom';
// import aboutImg from '../../assets/images/about.jpg';

class About extends React.Component {
  state = {
    isOpen: false
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };
  render() {
    return (
      <section id="about" className="about-area ptb-80 bg-f6f6f6">
        <div className="container">
          <div className="section-title">
            <h2>
              Sobre <span>Nosotros</span>
            </h2>
            <p>
              Empresa ubicada en la ciudad de Panamá, con sucursal en Brasil y
              Chile; especializada en consultoría y asesoría de negocios
              internacionales.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="about-addax">
                <div className="section-title">
                  <h2>
                    En nuestro <span>Grupo</span>
                  </h2>
                  <p>
                    Aceptando el compromiso con nuestros clientes, LUGAL
                    INTERNATIONAL GROUP creó un núcleo de profesionales y
                    empresarios altamente capacitados; con gran experiencia y
                    alcance en diversas áreas, siendo garantes Del marco
                    jurídico internacional, con fundamento en la Cámara Comercio
                    Internacional, las legislaciones respectivas y las
                    costumbres comerciales de los países participantes en cada
                    caso. Nuestro compromiso es ofrecer opciones y estrategias
                    más adecuadas para lograr los resultados empresariales
                    esperados, contando siempre con la participación directa de
                    los socios de LUGAL INTERNATIONAL GROUP.
                  </p>
                </div>

                <ul className="pull-left">
                  <li>
                    <i className="fa fa-check"></i>Compromiso
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Lealtad
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Colaboración
                  </li>
                </ul>

                <ul>
                  <li>
                    <i className="fa fa-check"></i>Efectividad
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Resultados
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Transparencia
                  </li>
                </ul>

                {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
              </div>
            </div>

            {/* <div className="col-lg-6 col-md-12">
                           
                        </div> */}
          </div>
        </div>
      </section>
    );
  }
}

export default About;
